import { PERMISSION_NAMES } from '../../../constants/permissionNames';

export const initialChat = {
  timestamp: null,
  description: null,
  lastMessageId: null,
  chatId: null,
  leftLastRead: null,
  lastMessageSnippet: null,
  rightLastRead: null,
  title: null,
  // TODO: temporary solution for secret chats
  isSecret: false,
  userdata: {
    files: [],
    mapping: [
      // TODO: remove this when it will be ready the conversation userdata API
      PERMISSION_NAMES.CHAT_ADMIN,
      PERMISSION_NAMES.CHAT_MANAGE,
      PERMISSION_NAMES.CHAT_READ,
      PERMISSION_NAMES.CHAT_WRITE,
      PERMISSION_NAMES.CHAT_UPDATE,
    ],
  },
};

export const initialMessage = {
  author: null,
  timestamp: null,
  chatId: null,
  messageId: null,
  content: {
    message: null,
    file: null,
  },
  metadata: {
    schedule: null,
    disappear: null,
  },
};
